import '@take-2/views/movie/overview/partials/_rtAudienceReviews.js';
import '@take-2/views/movie/overview/partials/_rtCriticReviews.js';
import '@take-2/views/movie/reviews/partials/_movieRatingsTabs.js';
